import { createContext } from 'react';
let realContext = null;
function getContext() {
  if (!realContext) {
    realContext = createContext(null);
    if (process.env.NODE_ENV !== 'production') {
      realContext.displayName = 'ReactRedux';
    }
  }
  return realContext;
}
export const ReactReduxContext = /*#__PURE__*/new Proxy({}, /*#__PURE__*/new Proxy({}, {
  get(_, handler) {
    const target = getContext(); // @ts-ignore

    return function (_target) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return Reflect[handler](target, ...args);
    };
  }
}));
export default ReactReduxContext;